<template>
  <div class="table-container">
    <div class="table-container-buttons"></div>
    <div class="table-container-wrapper companies">
      <div class="table-container-wrapper-header">
        <div class="table-container-wrapper-header__views">
          Показать
          <v-select
            v-model="selectedCount"
            :items="changeCount"
            :menu-props="{ bottom: true, offsetY: true }"
            dense
            height="20"
            hide-details
            solo
          ></v-select>
          записей
        </div>
        <div class="table-container-wrapper-header__search">
          Поиск:
          <v-text-field
            dense
            height="20"
            hide-details
            label=""
            solo
          ></v-text-field>
        </div>
      </div>
      <table class="table-container-wrapper-main twelve_columns">
        <thead class="table-container-wrapper-main-header">
          <tr>
            <th class="table-container-wrapper-main-header__title">
              <span class="table-container-wrapper-main-header__title__text">#</span>
            </th>
            <th
              v-for="(title, index) in titles"
              :key="index"
              class="table-container-wrapper-main-header__title"
              data-type="text-short"
            >
              <span class="table-container-wrapper-main-header__title__text">{{
                title.TEXT
              }}</span>
              <img
                :src="require('/src/assets/svg/sort_arrow.svg')"
                alt=""
                class="table-container-wrapper-main-header__title__sort"
                style="position: absolute; top: 5px; right: 5px"
              />
              <!--              <span class="resize-handle"></span>-->
            </th>
            <th class="table-container-wrapper-main-header__title actions">
              <span class="table-container-wrapper-main-header__title__text"
                >Доступные действия</span
              >
            </th>
          </tr>
        </thead>
        <tbody class="table-container-wrapper-main-items">
          <tr v-for="(row, index) in listItems" :key="index">
            <td class="row-number">{{ index + 1 }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.physical_address }}</td>
            <td>{{ row.created_at }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.telephone }}</td>
            <td>{{ row.site }}</td>
            <td>{{ row.instagram }}</td>
            <td>{{ row.lat || "—" }}</td>
            <!-- после инстаграма -->
            <td>{{ row.long || "—" }}</td>
            <!-- после широты -->
            <td style="width: 100px">
              <!-- теперь логотип -->
              <img
                v-if="row._logotype_company"
                :src="row._logotype_company.thumb_path"
                alt=""
                class="main_img"
                style="object-fit: contain; width: 100%; height: 100%"
              />
            </td>
            <td class="buttons">
              <v-btn
                class="text-capitalize"
                color="blue lighten-1"
                style="font-size: 12px"
                @click="onEditCard(row)"
              >
                <v-icon color="white" small>mdi-pencil-box-multiple</v-icon>
                <span class="table-container-buttons__text">Изменить</span>
              </v-btn>
              <v-btn
                class="text-capitalize"
                color="error"
                @click="onDelCard(row)"
              >
                <v-icon color="white" small>mdi-trash-can</v-icon>
                <span class="table-container-buttons__text">Удалить</span>
              </v-btn>
              <v-btn
                class="text-capitalize"
                color="orange lighten-1"
                @click="onShowCard(row)"
              >
                <v-icon color="white" small>mdi-eye</v-icon>
                <span class="table-container-buttons__text">Просмотр</span>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- MODAL  -->
    <v-dialog v-model="showCard" max-width="600">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ companyTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="curCompany.name"
                    :disabled="!editable"
                    :rules="nameRules"
                    clearable
                    label="Имя компании"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <div class="branches-block">
                    <div class="branches-block__header">
                      <span class="branches-block__title">Адреса и филиалы</span>
                      <v-btn
                        v-if="editable"
                        icon
                        small
                        color="primary"
                        @click="addBranchTab()"
                      >
                        <v-icon>mdi-plus-circle</v-icon>
                      </v-btn>
                    </div>

                    <v-tabs v-model="branchTab" show-arrows dense>
                      <v-tab>Головной</v-tab>
                      <v-tab v-for="(branch, index) in listBranches" :key="index">
                        {{ branchTabLabel(branch, index) }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="branchTab">
                      <v-tab-item>
                        <v-row dense style="padding-top: 12px">
                          <v-col cols="12">
                            <v-text-field
                              v-model="curCompany.yandex_maps_url"
                              :disabled="!editable"
                              clearable
                              hide-details
                              label="Ссылка на компанию в Я.Картах"
                              placeholder="https://yandex.ru/maps/org/..."
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    curCompany.lat = lat;
                                    curCompany.long = long;
                                  },
                                  (address) => {
                                    curCompany.physical_address = address;
                                  },
                                  { preventInsert: false }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="curCompany.physical_address"
                              :disabled="!editable"
                              clearable
                              hide-details
                              label="Адрес компании"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="curCompany.email"
                              :disabled="!editable"
                              :rules="emailRules"
                              clearable
                              hide-details="auto"
                              label="Email"
                              @input="curCompany.email = sanitizeEmail($event)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="curCompany.telephone"
                              :disabled="!editable"
                              :rules="phoneRules"
                              clearable
                              hide-details="auto"
                              type="tel"
                              maxlength="18"
                              label="Телефон компании"
                              @input="curCompany.telephone = formatPhone($event)"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="curCompany.lat"
                              :disabled="!editable"
                              :rules="latRules"
                              clearable
                              hide-details="auto"
                              label="Широта (Latitude)"
                              type="number"
                              step="0.000001"
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    curCompany.lat = lat;
                                    curCompany.long = long;
                                  },
                                  (address) => {
                                    curCompany.physical_address = address;
                                  }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="curCompany.long"
                              :disabled="!editable"
                              :rules="longRules"
                              clearable
                              hide-details="auto"
                              label="Долгота (Longitude)"
                              type="number"
                              step="0.000001"
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    curCompany.lat = lat;
                                    curCompany.long = long;
                                  },
                                  (address) => {
                                    curCompany.physical_address = address;
                                  }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              v-model="curCompany.id_city"
                              :disabled="!editable"
                              :items="listCities"
                              item-text="city"
                              item-value="id"
                              clearable
                              hide-details
                              label="Город"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <div style="display: flex; gap: 4px">
                              <v-autocomplete
                                :value="curCompany.id_director"
                                :items="usersForSelect"
                                item-text="fullName"
                                item-value="id"
                                :disabled="!editable"
                                clearable
                                hide-details
                                label="Руководитель"
                                @change="curCompany.id_director = $event"
                              ></v-autocomplete>
                              <v-btn
                                v-if="editable"
                                icon
                                small
                                color="primary"
                                @click="openUserDialog('id_director')"
                              >
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </div>
                            <div
                              v-if="curCompany.id_director"
                              class="contact-details"
                            >
                              <div>
                                Телефон:
                                {{
                                  getUserById(curCompany.id_director)
                                    ?.telephone || "—"
                                }}
                              </div>
                              <div>
                                Email:
                                {{
                                  getUserById(curCompany.id_director)?.email ||
                                  "—"
                                }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="display: flex; gap: 4px">
                              <v-autocomplete
                                :value="curCompany.id_manager"
                                :items="usersForSelect"
                                item-text="fullName"
                                item-value="id"
                                :disabled="!editable"
                                clearable
                                hide-details
                                label="Менеджер"
                                @change="curCompany.id_manager = $event"
                              ></v-autocomplete>
                              <v-btn
                                v-if="editable"
                                icon
                                small
                                color="primary"
                                @click="openUserDialog('id_manager')"
                              >
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </div>
                            <div
                              v-if="curCompany.id_manager"
                              class="contact-details"
                            >
                              <div>
                                Телефон:
                                {{
                                  getUserById(curCompany.id_manager)
                                    ?.telephone || "—"
                                }}
                              </div>
                              <div>
                                Email:
                                {{
                                  getUserById(curCompany.id_manager)?.email ||
                                  "—"
                                }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-tab-item>
                      <v-tab-item
                        v-for="(branch, index) in listBranches"
                        :key="index"
                      >
                        <v-row dense style="padding-top: 12px">
                          <v-col cols="12">
                            <v-text-field
                              :value="branch.yandex_maps_url"
                              :disabled="!editable"
                              clearable
                              hide-details
                              label="Ссылка на компанию в Я.Картах"
                              placeholder="https://yandex.ru/maps/org/..."
                              @input="
                                updateBranchField(
                                  index,
                                  'yandex_maps_url',
                                  $event
                                )
                              "
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    updateBranchField(index, 'lat', lat);
                                    updateBranchField(index, 'long', long);
                                  },
                                  (address) => {
                                    updateBranchField(
                                      index,
                                      'physical_address',
                                      address
                                    );
                                  },
                                  { preventInsert: false }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              :value="branch.physical_address"
                              :disabled="!editable"
                              clearable
                              hide-details
                              label="Адрес филиала"
                              @input="
                                updateBranchField(
                                  index,
                                  'physical_address',
                                  $event
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="branch.email"
                              :disabled="!editable"
                              :rules="emailRules"
                              clearable
                              hide-details="auto"
                              label="Email филиала"
                              @input="
                                updateBranchField(
                                  index,
                                  'email',
                                  sanitizeEmail($event)
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="branch.telephone"
                              :disabled="!editable"
                              clearable
                              hide-details
                              type="tel"
                              maxlength="18"
                              label="Телефон филиала"
                              @input="
                                updateBranchField(
                                  index,
                                  'telephone',
                                  formatPhone($event)
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="branch.lat"
                              :disabled="!editable"
                              clearable
                              hide-details
                              type="number"
                              step="0.000001"
                              label="Широта (Latitude)"
                              @input="updateBranchField(index, 'lat', $event)"
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    updateBranchField(index, 'lat', lat);
                                    updateBranchField(index, 'long', long);
                                  },
                                  (address) => {
                                    updateBranchField(
                                      index,
                                      'physical_address',
                                      address
                                    );
                                  }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="branch.long"
                              :disabled="!editable"
                              clearable
                              hide-details
                              type="number"
                              step="0.000001"
                              label="Долгота (Longitude)"
                              @input="updateBranchField(index, 'long', $event)"
                              @paste="
                                onCoordsPaste(
                                  $event,
                                  (lat, long) => {
                                    updateBranchField(index, 'lat', lat);
                                    updateBranchField(index, 'long', long);
                                  },
                                  (address) => {
                                    updateBranchField(
                                      index,
                                      'physical_address',
                                      address
                                    );
                                  }
                                )
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              :value="branch.id_city"
                              :disabled="!editable"
                              :items="listCities"
                              item-text="city"
                              item-value="id"
                              clearable
                              hide-details
                              label="Город"
                              @change="updateBranchField(index, 'id_city', $event)"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <div style="display: flex; gap: 4px">
                              <v-autocomplete
                                :value="branch.id_director"
                                :items="usersForSelect"
                                item-text="fullName"
                                item-value="id"
                                :disabled="!editable"
                                clearable
                                hide-details
                                label="Руководитель"
                                @change="
                                  updateBranchField(
                                    index,
                                    'id_director',
                                    $event
                                  )
                                "
                              ></v-autocomplete>
                              <v-btn
                                v-if="editable"
                                icon
                                small
                                color="primary"
                                @click="openUserDialog('id_director', index)"
                              >
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </div>
                            <div
                              v-if="branch.id_director"
                              class="contact-details"
                            >
                              <div>
                                Телефон:
                                {{
                                  getUserById(branch.id_director)
                                    ?.telephone || "—"
                                }}
                              </div>
                              <div>
                                Email:
                                {{
                                  getUserById(branch.id_director)?.email ||
                                  "—"
                                }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="display: flex; gap: 4px">
                              <v-autocomplete
                                :value="branch.id_manager"
                                :items="usersForSelect"
                                item-text="fullName"
                                item-value="id"
                                :disabled="!editable"
                                clearable
                                hide-details
                                label="Менеджер"
                                @change="
                                  updateBranchField(index, 'id_manager', $event)
                                "
                              ></v-autocomplete>
                              <v-btn
                                v-if="editable"
                                icon
                                small
                                color="primary"
                                @click="openUserDialog('id_manager', index)"
                              >
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </div>
                            <div
                              v-if="branch.id_manager"
                              class="contact-details"
                            >
                              <div>
                                Телефон:
                                {{
                                  getUserById(branch.id_manager)?.telephone ||
                                  "—"
                                }}
                              </div>
                              <div>
                                Email:
                                {{
                                  getUserById(branch.id_manager)?.email || "—"
                                }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-tab-item>
                    </v-tabs-items>

                    <v-tooltip v-if="editable && branchTab > 0" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          small
                          color="error"
                          class="branches-block__remove"
                          v-bind="attrs"
                          v-on="on"
                          @click="removeBranchTab(branchTab - 1)"
                        >
                          Удалить филиал
                        </v-btn>
                      </template>
                      <span>Удалить текущий «{{ currentBranchLabel }}» филиал</span>
                    </v-tooltip>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="curCompany.site"
                    :disabled="!editable"
                    clearable
                    hide-details
                    label="Сайт компании"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="curCompany.instagram"
                    :disabled="!editable"
                    clearable
                    hide-details
                    label="Инстаграм компании"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="curCompany.description"
                    :disabled="!editable"
                    clearable
                    hide-details
                    label="Описание компании"
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="curCompany.ids_brands"
                    :items="listBrands"
                    :disabled="!editable"
                    item-text="name"
                    item-value="id"
                    label="Обслуживаемые бренды"
                    multiple
                    chips
                    clearable
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <div class="roles-block">
                    <div class="roles-block__title">Роли</div>
                    <v-checkbox
                      v-model="curCompany.is_installation_company"
                      :disabled="!editable"
                      label="Монтажная компания"
                      hide-details
                      dense
                    ></v-checkbox>
                    <v-checkbox
                      v-model="curCompany.is_dealer"
                      :disabled="!editable"
                      label="Дилер"
                      hide-details
                      dense
                    ></v-checkbox>
                    <v-checkbox
                      v-model="curCompany.is_designer"
                      :disabled="!editable"
                      label="Проектировщик"
                      hide-details
                      dense
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  style="display: flex; align-items: center; gap: 12px"
                >
                  <div
                    v-if="curCompany._logotype_company"
                    style="position: relative; flex-shrink: 0; width: 60px; height: 60px"
                  >
                    <v-img
                      :src="curCompany._logotype_company.thumb_path"
                      width="60"
                      height="60"
                      contain
                    ></v-img>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="editable"
                          icon
                          color="error"
                          style="position: absolute; top: -12px; right: -12px; background: white"
                          v-on="on"
                          @click="deleteLogo()"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </template>
                      <span>Удалить логотип</span>
                    </v-tooltip>
                  </div>
                  <v-file-input
                    v-model="file"
                    :disabled="!editable || !!curCompany._logotype_company"
                    accept="image/*"
                    clearable
                    :label="
                      curCompany._logotype_company
                        ? 'Уже загружен логотип'
                        : 'Логотип компании'
                    "
                    style="flex: 1"
                    @change="fileIsNew = true"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCard()">
            Закрыть
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!valid || !editable"
            @click="saveCreate()"
          >
            Сохранить изменения
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delCard" max-width="600">
      <v-card>
        <v-card-title>
          <span class="text-h5">Вы точно хотите удалить компанию?</span>
        </v-card-title>
        <v-card-text>
          {{ companyTitle }} будет удалена из списка компаний со всеми данными
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteCard()"> Да</v-btn>
          <v-btn color="blue darken-1" text @click="delCard = false">
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="userDialog.show" max-width="500">
      <v-card>
        <v-card-title>
          <span class="text-h5">Новый пользователь</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="userDialogForm.last_name"
            :rules="nameRules"
            required
            clearable
            hide-details="auto"
            label="Фамилия"
          ></v-text-field>
          <v-text-field
            v-model="userDialogForm.first_name"
            :rules="nameRules"
            required
            clearable
            hide-details="auto"
            label="Имя"
          ></v-text-field>
          <v-text-field
            v-model="userDialogForm.middle_name"
            clearable
            label="Отчество"
          ></v-text-field>
          <v-text-field
            :value="userDialogForm.email"
            clearable
            label="Email"
            @input="userDialogForm.email = sanitizeEmail($event)"
          ></v-text-field>
          <v-text-field
            :value="userDialogForm.telephone"
            clearable
            type="tel"
            maxlength="18"
            label="Телефон"
            @input="userDialogForm.telephone = formatPhone($event)"
          ></v-text-field>
          <div style="font-size: 12px; color: rgba(0, 0, 0, 0.6)">
            Фамилия и имя обязательны, а также укажите email или телефон
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeUserDialog()">
            Отмена
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="
              !userDialogForm.last_name ||
              !userDialogForm.first_name ||
              (!userDialogForm.email && !userDialogForm.telephone)
            "
            @click="submitUserDialog()"
          >
            Создать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Companies",
  data: () => ({
    titles: [
      { ID: 1, TEXT: "Имя компании", VALUE: "name" },
      { ID: 2, TEXT: "Адрес компании", VALUE: "physical_address" },
      { ID: 3, TEXT: "Дата создания", VALUE: "created_at" },
      { ID: 4, TEXT: "Email", VALUE: "email" },
      { ID: 5, TEXT: "Телефон компании", VALUE: "telephone" },
      { ID: 6, TEXT: "Сайт компании", VALUE: "site" },
      { ID: 7, TEXT: "Инстаграм компании", VALUE: "instagram" },
      { ID: 8, TEXT: "Широта", VALUE: "lat" },
      { ID: 9, TEXT: "Долгота", VALUE: "long" },
      { ID: 10, TEXT: "Логотип компании", VALUE: "logo" },
    ],
    changeCount: [5, 10, 15, 20, 25],
    selectedCount: 10,
    page: 1,
    showCard: false,
    companyTitle: "Новая компания",
    valid: false,
    nameRules: [
      (v) => !!v || "Обязательное поле",
      (v) => !v || v.length <= 100 || "Не должно содержать больше 100 символов",
    ],
    emailRules: [(v) => !v || /.+@.+\..+/.test(v) || "Некорректный email"],
    latRules: [(v) => !v || (v >= -90 && v <= 90) || "Широта от -90 до 90"],
    longRules: [
      (v) => !v || (v >= -180 && v <= 180) || "Долгота от -180 до 180",
    ],
    phoneRules: [
      (v) => !v || /^[\d\s\-\+\(\)]+$/.test(v) || "Некорректный номер телефона",
    ],
    file: null,
    fileIsNew: false,
    delCard: false,
    editable: true,
    branchTab: 0,
    removedBranchIds: [],
    cityDetectTimer: null,
    userDialog: {
      show: false,
      field: null,
      branchIndex: null,
    },
    userDialogForm: {
      last_name: "",
      first_name: "",
      middle_name: "",
      email: "",
      telephone: "",
    },
  }),
  computed: {
    ...mapState({
      listItems: (state) => state.Companies.listCompanies,
      listBrands: (state) => state.Brands.listBrands,
      listBranches: (state) => state.CompanyBranches.listBranches,
      listCities: (state) => state.CompanyBranches.listCities,
      listUsers: (state) => state.UsersModule.listEntries,
    }),
    usersForSelect() {
      return this.listUsers.map((user) => ({
        ...user,
        fullName:
          [user.last_name, user.first_name, user.middle_name]
            .filter(Boolean)
            .join(" ") ||
          user.email ||
          `Пользователь #${user.id}`,
      }));
    },
    curCompany: {
      get() {
        return this.$store.state.Companies.company;
      },
      set(value) {
        this.$store.commit("Companies/setCompanyData", value);
      },
    },
    currentBranchLabel() {
      const index = this.branchTab - 1;
      const branch = this.listBranches[index];
      return branch ? this.branchTabLabel(branch, index) : "";
    },
  },
  watch: {
    "$route.query.action": {
      immediate: true,
      handler(action) {
        if (action === "create") {
          this.openCreateModal();
          this.$router.replace({ query: {} }).catch(() => {});
        }
      },
    },
  },
  created() {
    this.loadCompanies();
    this.$store.dispatch("getListBrands");
    this.getListCities();
    this.getUsersList();
  },
  methods: {
    ...mapActions("Companies", [
      "getListCompanies",
      "createCompany",
      "updateCompany",
      "deleteCompany",
      "clearCompany",
    ]),
    ...mapMutations("Companies", ["setCompanyData", "clearCompany"]),
    ...mapActions("CompanyBranches", [
      "getListBranches",
      "getListCities",
      "getNearestCity",
      "createBranch",
      "updateBranch",
      "deleteBranch",
    ]),
    ...mapMutations("CompanyBranches", [
      "addBranch",
      "updateBranchAt",
      "removeBranchAt",
      "clearListBranches",
    ]),
    ...mapActions("UsersModule", {
      getUsersList: "getListEntries",
      createUserEntry: "createEntry",
    }),

    getUserById(id) {
      return this.listUsers.find((user) => user.id === id) || null;
    },

    openUserDialog(field, branchIndex = null) {
      this.userDialog = { show: true, field, branchIndex };
      this.userDialogForm = {
        last_name: "",
        first_name: "",
        middle_name: "",
        email: "",
        telephone: "",
      };
    },

    closeUserDialog() {
      this.userDialog.show = false;
    },

    async submitUserDialog() {
      const response = await this.createUserEntry({
        last_name: this.userDialogForm.last_name,
        first_name: this.userDialogForm.first_name,
        middle_name: this.userDialogForm.middle_name,
        email: this.userDialogForm.email || null,
        telephone: this.userDialogForm.telephone || null,
      });

      const newUserId = response?.data?.id;
      if (!newUserId) return;

      if (this.userDialog.branchIndex === null) {
        this.curCompany[this.userDialog.field] = newUserId;
      } else {
        this.updateBranchField(
          this.userDialog.branchIndex,
          this.userDialog.field,
          newUserId
        );
      }

      await this.getUsersList();
      this.closeUserDialog();
    },

    addBranchTab() {
      this.addBranch({ id_company: this.curCompany.id || null });
      this.$nextTick(() => {
        this.branchTab = this.listBranches.length;
      });
    },

    removeBranchTab(index) {
      const branch = this.listBranches[index];
      if (branch?.id) {
        this.removedBranchIds.push(branch.id);
      }
      this.removeBranchAt(index);
      if (this.branchTab > this.listBranches.length) {
        this.branchTab = this.listBranches.length;
      }
    },

    updateBranchField(index, field, value) {
      this.updateBranchAt({ index, data: { [field]: value } });
      if (field === "lat" || field === "long") {
        this.scheduleDetectBranchCity(index);
      }
    },

    sanitizeEmail(value) {
      if (!value) return "";
      return value.replace(/[^a-zA-Z0-9@._%+-]/g, "");
    },

    formatPhone(value) {
      if (!value) return "";

      let digits = String(value).replace(/\D/g, "");
      if (digits.startsWith("8")) digits = "7" + digits.slice(1);
      if (!digits.startsWith("7")) digits = "7" + digits;
      digits = digits.slice(0, 11);

      let result = "+7";
      if (digits.length > 1) result += " (" + digits.slice(1, 4);
      if (digits.length >= 4) result += ") " + digits.slice(4, 7);
      if (digits.length >= 7) result += "-" + digits.slice(7, 9);
      if (digits.length >= 9) result += "-" + digits.slice(9, 11);
      return result;
    },

    onCoordsPaste(event, applyCoords, applyAddress, options = {}) {
      const { preventInsert = true } = options;
      const text = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      // Ссылка Яндекс.Карт: ll=долгота,широта — порядок обратный обычной паре координат
      const urlMatch = text.match(
        /[?&]ll=(-?\d+\.?\d*)(?:,|%2C)(-?\d+\.?\d*)/i
      );
      const pairMatch = text.match(
        /(-?\d+(?:[.,]\d+)?)\s*[,;]\s*(-?\d+(?:[.,]\d+)?)/
      );

      let lat;
      let long;
      if (urlMatch) {
        long = urlMatch[1];
        lat = urlMatch[2];
      } else if (pairMatch) {
        lat = pairMatch[1].replace(",", ".");
        long = pairMatch[2].replace(",", ".");
      } else {
        return;
      }

      if (preventInsert) event.preventDefault();
      applyCoords(lat, long);

      if (applyAddress) {
        this.geocodeAddress(lat, long).then((address) => {
          if (address) applyAddress(address);
        });
      }
    },

    async geocodeAddress(lat, long) {
      const apiKey = process.env.VUE_APP_YANDEX_MAPS_API_KEY;
      if (!apiKey) {
        console.warn(
          "VUE_APP_YANDEX_MAPS_API_KEY не задан — автоподстановка адреса недоступна"
        );
        return null;
      }

      try {
        const response = await fetch(
          `https://geocode-maps.yandex.ru/v1?apikey=${apiKey}&geocode=${long},${lat}&format=json&lang=ru_RU&results=1`
        );
        const data = await response.json();
        const geoObject =
          data?.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject;
        return geoObject?.metaDataProperty?.GeocoderMetaData?.text || null;
      } catch (e) {
        console.log(e);
        return null;
      }
    },

    scheduleDetectBranchCity(index) {
      clearTimeout(this.cityDetectTimer);
      this.cityDetectTimer = setTimeout(() => {
        this.detectBranchCity(index);
      }, 700);
    },

    async detectBranchCity(index) {
      const branch = this.listBranches[index];
      if (!branch || !branch.lat || !branch.long) return;

      const city = await this.getNearestCity({
        lat: branch.lat,
        long: branch.long,
      });
      if (city && city.id) {
        this.updateBranchAt({ index, data: { id_city: city.id } });
      }
    },

    branchTabLabel(branch, index) {
      const city = this.listCities.find((item) => item.id === branch.id_city);
      return city?.city || `Филиал ${index + 1}`;
    },

    async loadCompanies() {
      await this.getListCompanies();
    },

    openCreateModal() {
      this.clearCompany();
      this.clearListBranches();
      this.removedBranchIds = [];
      this.branchTab = 0;
      this.file = null;
      this.fileIsNew = false;
      this.companyTitle = "Новая компания";
      this.showCard = true;
    },

    async onEditCard(row) {
      this.setCompanyData({
        id: row.id,
        name: row.name,
        physical_address: row.physical_address,
        yandex_maps_url: row.yandex_maps_url,
        email: row.email,
        telephone: row.telephone,
        site: row.site,
        instagram: row.instagram,
        description: row.description,
        lat: row.lat,
        long: row.long,
        ids_brands: row.ids_brands || [],
        _logotype_company: row._logotype_company || null,
        is_installation_company: !!row.is_installation_company,
        is_dealer: !!row.is_dealer,
        is_designer: !!row.is_designer,
        id_director: row.id_director,
        id_manager: row.id_manager,
        id_city: row.id_city,
      });
      this.fileIsNew = false;
      this.file = null;
      this.removedBranchIds = [];
      this.branchTab = 0;
      await this.getListBranches(row.id);
      this.companyTitle = row.name;
      this.showCard = true;
    },

    onDelCard(row) {
      this.delCard = true;
      this.companyTitle = row.name;
      this.setCompanyData({ id: row.id });
    },

    async deleteCard() {
      await this.deleteCompany();
      await this.loadCompanies();
      this.delCard = false;
    },

    async onShowCard(row) {
      await this.onEditCard(row);
      this.editable = false;
    },

    async deleteLogo() {
      await this.$store.dispatch("deleteFileGeneral", this.curCompany._logotype_company.id);
      this.setCompanyData({ _logotype_company: null });
    },

    closeCard() {
      this.showCard = false;
      this.editable = true;
      this.file = null;
      this.fileIsNew = false;
      this.clearCompany();
      this.clearListBranches();
      this.removedBranchIds = [];
      this.branchTab = 0;
    },

    async saveCreate() {
      if (!this.curCompany.name) return;

      let companyId;
      if (this.curCompany.id) {
        await this.updateCompany();
        companyId = this.curCompany.id;
      } else {
        const response = await this.createCompany();
        companyId = response?.data?.id;
      }

      if (this.file && this.fileIsNew && companyId) {
        if (this.curCompany._logotype_company) {
          await this.$store.dispatch("deleteFileGeneral", this.curCompany._logotype_company.id);
        }
        await this.$store.dispatch("uploadFileGeneral", {
          uuid: crypto.randomUUID(),
          id_company: companyId,
          file: this.file,
        });
        this.file = null;
      }

      if (companyId) {
        for (const branch of this.listBranches) {
          const payload = { ...branch, id_company: companyId };
          if (branch.id) {
            await this.updateBranch(payload);
          } else {
            await this.createBranch(payload);
          }
        }
        for (const id of this.removedBranchIds) {
          await this.deleteBranch(id);
        }
        this.removedBranchIds = [];
      }

      await this.loadCompanies();
      this.showCard = false;
    },

  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/table";

.table-container-wrapper.companies {
  overflow: auto;
}

.row-number {
  text-align: center;
  color: #9e9e9e;
  font-size: 13px;
  width: 40px;
}

.roles-block {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px 16px;

  &__title {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 4px;
  }
}

.branches-block {
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px 16px 48px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }

  &__empty {
    font-size: 13px;
    color: #9e9e9e;
    padding: 8px 0;
  }

  &__remove {
    position: absolute;
    bottom: 4px;
    right: 4px;
    font-size: 11px;
    text-transform: none;
    letter-spacing: normal;
    opacity: 0.35;
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 1;
    }
  }
}

.contact-details {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  padding: 4px 0 0;

  div {
    padding: 1px 0;
  }
}
</style>
